export interface EpgRequestArgs {
  startTime: number;
  endTime: number;
  linearIdList?: (number | undefined)[];
  orderBy?: string; // START_DATE_ASC
  forceUpdate?: boolean;
  loadMosaicPrograms?: boolean;
}

export const epgArgsToKsql = (args: EpgRequestArgs) => {
  return `(and linear_media_id:'${args?.linearIdList?.join(',')}' (and end_date >= '${
    args.startTime / 1000
  }' start_date  <= '${args.endTime / 1000}') asset_type='epg' auto_fill= true)`;
};

export const epgMosaicArgsToKsql = (args: EpgRequestArgs, externalIds: string[]) => {
  return `(and IsMosaicEvent='1' MosaicInfo='mosaic' (or ${externalIds
    .map((it) => `externalId='${it}'`)
    .join(' ')}) (and end_date >= '${args.startTime / 1000}' start_date  <= '${
    args.endTime / 1000
  }') asset_type='epg' auto_fill= true)`;
};

export const epgArgsToKsqlSingle = (args: EpgRequestArgs, singleTimestamp = Date.now()) => {
  return `(and linear_media_id:'${args?.linearIdList?.join(',')}'  end_date >= '${Math.ceil(
    singleTimestamp / 1000,
  )}' start_date <= '${Math.ceil(singleTimestamp / 1000)}' asset_type='epg' auto_fill= true)`;
};

export const epgMosaicArgsToKsqlSingle = (
  args: EpgRequestArgs,
  externalIds: string[],
  singleTimestamp = Date.now(),
) => {
  return `(and IsMosaicEvent='1' MosaicInfo='mosaic' (or ${externalIds
    .map((it) => `externalId='${it}'`)
    .join(' ')})  end_date >= '${Math.ceil(singleTimestamp / 1000)}' start_date <= '${Math.ceil(
    singleTimestamp / 1000,
  )}')`;
};

export const epgArgsToKsqlProgramLeft = (timestamp: number, linearId: number) => {
  return `(and linear_media_id:'${linearId}'  end_date < '${Math.ceil(
    timestamp / 1000,
  )}' asset_type='epg' auto_fill= true)`;
};

export const epgArgsToKsqlProgramRight = (timestamp: number, linearId: number) => {
  return `(and linear_media_id:'${linearId}'  start_date > '${Math.ceil(
    timestamp / 1000,
  )}' asset_type='epg' auto_fill= true)`;
};
